import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { AfterViewInit, Component, Injector, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CreatePublicPricingComponent } from '@components/entities/pricings/create-public-pricing/create-public-pricing.component';
import { ChargingStationDto } from '@dto/chargingStationDto';
import { IEntity } from '@interfaces/entity';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { PricingsService } from '@services/entity/pricings.service';
import { FormService } from '@services/form/form.service';

@Component({
  selector: 'app-create-public-pricing-dialog-content',
  templateUrl: './create-public-pricing-dialog-content.component.html',
  styleUrls: ['./create-public-pricing-dialog-content.component.scss']
})
export class CreatePublicPricingDialogContentComponent extends AbstractDialogContent implements OnInit, AfterViewInit {

  public className = 'CreatePublicPricingDialogContentComponent';

  public mapUrl: any
  private chargingStation: ChargingStationDto;

  @Input() private ownerUserId: string;
  @ViewChild('createPublicPricingComponent') createPublicPricingComponent: CreatePublicPricingComponent;

  constructor(
    @Inject('BASE_URL') private baseUrl: string,
    public activeModal: NgbActiveModal,
    public pricingsService: PricingsService,
    public chargingStationsService: ChargingStationsService,
    public formService: FormService,
    private sanitizer: DomSanitizer,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngAfterViewInit() {
    this.createPublicPricingComponent.ownerUserId = this.ownerUserId;
    // this.setMapUrl()
  }

  newEntityEvent(entity: IEntity) {
    this.activeModal.close();
  }

  setMapUrl() {
    this.chargingStationsService.getChargingStationsOfCurrentCustomer().subscribe(chargingStations => {
      this.chargingStation = chargingStations.find(chargingStation => chargingStation.isPublicCharge)
      if (!this.chargingStation) this.chargingStation = chargingStations[0]
      this.mapUrl = `${this.baseUrl}public-charge-plans?cs=${this.chargingStation.id}`
    }, error => {
      console.error(error)
    })
  }
}
